import { UserRound, ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

export const Team = () => (
  <section id="team" data-testid="team-section" className="py-24 sm:py-32 bg-sa-cream">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Reveal>
            <SectionLabel testId="team-label">Meet our team</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-sa-espresso mt-6">
              The people behind
              <span className="italic text-sa-bronze"> your care</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-body text-base sm:text-lg text-sa-mocha mt-6 leading-relaxed max-w-md">
              MS Pet Hospital is led by Dr. Sheriyar and a team of experienced
              veterinary doctors who genuinely love animals. Full profiles are on
              their way.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div
            data-testid="team-placeholder-card"
            className="relative bg-sa-beige rounded-[32px] p-8 sm:p-10 border border-sa-espresso/5"
          >
            <div className="flex items-center gap-5">
              <div className="w-20 h-20 rounded-full bg-sa-cream flex items-center justify-center shrink-0">
                <UserRound className="w-9 h-9 text-sa-bronze" />
              </div>
              <div>
                <h3 className="font-display text-2xl text-sa-espresso">
                  Dr. Sheriyar &amp; Team
                </h3>
                <span className="inline-block mt-1.5 rounded-full bg-sa-cream px-3 py-1 font-body text-[11px] uppercase tracking-wide text-sa-mocha font-semibold">
                  Veterinary doctors
                </span>
              </div>
            </div>
            <p className="font-body text-base text-sa-mocha mt-6 leading-relaxed">
              Full profiles coming soon — led by Dr. Sheriyar and a team of
              experienced veterinary doctors, warmly praised by pet owners for
              their patience, skill and genuine care for every animal.
            </p>
            <div className="mt-8 flex items-center gap-2 text-sa-bronze font-body text-sm font-semibold">
              <ArrowUpRight className="w-4 h-4" />
              Full team profiles coming soon
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Team;
